import dynamic from "next/dynamic";

// Export the new React Hook Form + MUI implementation lazily to avoid SSRed issues
// and keep bundle size small.

const LoanForm = dynamic(() => import("./loan-form-rhf"), { ssr: false });

export default LoanForm;
